.mappedin-map {
	.mappedin-control-container {
		position: absolute;
		left: 0px;
		top: 0px;
		bottom: 0px;
		right: 0px;
		pointer-events: none;
		font-family: 'InterUI-Regular', Helvetica, Arial, sans-serif;

		.mappedin-ctrl-top-left,
		.mappedin-ctrl-top-right,
		.mappedin-ctrl-bottom-left,
		.mappedin-ctrl-bottom-right {
			position: absolute;
			pointer-events: none;
		}

		.mappedin-ctrl-top-left {
			top: 0;
			left: 0;
		}

		.mappedin-ctrl-top-right {
			top: 0;
			right: 0;
		}

		.mappedin-ctrl-bottom-left {
			bottom: 0;
			left: 0;
		}

		.mappedin-ctrl-bottom-right {
			bottom: 0;
			right: 0;
		}

		.mappedin-ctrl-attrib {
			display: block;
			position: relative;
			pointer-events: auto;
			font: 9px/11px 'InterUI-Regular', Helvetica, Arial, sans-serif;
			padding: 3px 5px 1px 5px;
			background-color: rgba(255, 255, 255, 0.5);
			margin: 0;
			min-width: 11px;
			min-height: 11px;
			user-select: none;

			summary.mappedin-ctrl-attrib-button {
				appearance: none;
				list-style: none;
			}

			summary.mappedin-ctrl-attrib-button::-webkit-details-marker {
				display: none;
			}

			&.mappedin-compact .mappedin-ctrl-attrib-button,
			&.mappedin-compact-show .mappedin-ctrl-attrib-inner {
				display: inline-block;
			}

			&.mappedin-compact {
				background-color: transparent;
			}

			&.mappedin-compact-show {
				min-width: 15px;
				min-height: 15px;
				box-sizing: border-box;
				background-color: rgba(255, 255, 255, 0.5);
			}
		}

		.mappedin-ctrl-attrib-top-left {
			float: left;
			border-bottom-right-radius: 4px;
		}

		.mappedin-ctrl-attrib-top-right {
			float: right;
			border-bottom-left-radius: 4px;
		}

		.mappedin-ctrl-attrib-bottom-left {
			float: left;
			border-top-right-radius: 4px;
		}

		.mappedin-ctrl-attrib-bottom-right {
			float: right;
			border-top-left-radius: 4px;
		}
		.mappedin-ctrl-attrib-top-left,
		.mappedin-ctrl-attrib-bottom-left {
			padding: 3px 5px 1px 20px;
		}

		.mappedin-ctrl-attrib-inner {
			display: inline-block;
			margin-right: 12px;
		}

		.mappedin-ctrl-attrib-inner,
		.mappedin-ctrl-attrib-inner a {
			color: rgba(0, 0, 0, 0.75);
			text-decoration: none;
		}

		.mappedin-ctrl-attrib-inner-bold,
		.mappedin-ctrl-attrib-inner-bold a {
			font-weight: bold;
		}

		.mappedin-ctrl-attrib-inner a:hover {
			color: #017ef1;
			text-decoration: underline;
			cursor: pointer;
		}

		.mappedin-ctrl-attrib-button {
			display: none;
			cursor: pointer;
			position: absolute;
			width: 15px;
			height: 15px;
			box-sizing: border-box;
			border-radius: 50%;
			top: 0;
			right: 2px;
			border: 1px;
		}
		.mappedin-ctrl-attrib-top-left .mappedin-ctrl-attrib-button,
		.mappedin-ctrl-attrib-bottom-left .mappedin-ctrl-attrib-button {
			left: 2px;
		}
	}
}
